import { Component, EventEmitter, HostListener, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { RootScopeService } from 'src/app/services/root-scope.service';
import _, { random } from 'lodash';
import { WrapUpData } from '../../../models/WrapUpData';
import * as Constants from '../../../models/Constants';
import { GenesysCloudService } from '../../../services/genesys-cloud.service';
import { MatSelect } from '@angular/material/select';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { InteractionHistoryService } from '../../../services/interaction-history.service';
import { TimerService } from 'src/app/services/timer.service';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-unknown-caller',
  templateUrl: './unknown-caller.component.html',
  styleUrls: ['./unknown-caller.component.scss']
})
export class UnknownCallerComponent implements OnInit {

  @ViewChildren(MatSelect) select!: QueryList<MatSelect>;

  @HostListener('window:scroll', [])
  onScroll(): void {
    this.select.forEach((matSelect) => {
      if (matSelect.panelOpen) {
        matSelect.close();
      }
    });
  }
  @Input('id') id: any;
  @Output() dataRetain = new EventEmitter();

  tableData: any = [];
  dataSource: MatTableDataSource<Element> = new MatTableDataSource<Element>([]);
  displayedColumns = ['domain', 'topic', 'subTopic'];
  topicList: any = [];
  subTopicList: any = [];
  duplicateTopic: any = {};
  index = null;
  ten: number = Constants.TEN;
  topicArrow = Constants.TOPIC_ARROW;
  feedbackConst = Constants.FEEDBACK;
  showAddTopicModal: boolean = false;
  wrapUpData: WrapUpData = new WrapUpData;
  domainList: any = [];
  errorMsg: string = Constants.LEFT_NAV_CARD_FAILURE_MSG;
  commonErrorMsg: string = Constants.CUSTOMER_TYPE_FAILURE_MSG;
  loaderType = Constants.LOADER_TYPE.CARD;
  public userSubscription!: Subscription;

   private readonly DEFAULT_SIM_TOPIC = Constants.DEFAULT_SIM_TOPIC;


  constructor(public rootScope: RootScopeService,
    public genesysCloudService: GenesysCloudService,
    public customerService: CustBusService,
    public initHistService: InteractionHistoryService,
    public timerService: TimerService,
    public apiService: ApiService,
    public route: ActivatedRoute) {

  }

  ngOnInit(): void {
    this.userSubscription = this.route.params.subscribe((params: any) => {
      this.closeAlertPopup();

    setInterval(() => {
      this.getTimerVal();
    }, 1000);
    this.checkData();
    this.rootScope.activeCustTab.wrapUpData.contactName = Constants.unidentifiedCalls.UnknownCaller;
    this.getUnknownCallerLeftNavData();
  });
  }


  ngOnChanges(changes) {
    if (changes.id.currentValue != changes.id.previousValue) {
      this.checkData();
    }
  }


  addTopicModal() {
    this.showAddTopicModal = true;
    this.clearTopic();
  }


  closeAlertPopup() {
    this.showAddTopicModal = false;
  }


  /**CCR1-4329
   * @author Amarjeet
   *updateWrapupStatus()-Method to show cross call/chat icon after call/chat wrappedUp from care portal
   */
  updateWrapupStatus() {
    this.rootScope.activeCustTab.wrappedupCroosIcon = this.enableCloseButton();
    return this.rootScope.activeCustTab.wrappedupCroosIcon;
  }

  enableCloseButton() {

    if (this.rootScope.activeCustTab.activeChat || this.rootScope.activeCustTab.activeCall) {
      return false;
    }
    else return this.wrapUpValidation();
  }
  wrapUpValidation(){
    if (this.rootScope.activeCustTab?.wrapUpData.contactName &&
      this.rootScope.activeCustTab?.wrapUpData.unknownCallerType &&
      this.rootScope.activeCustTab?.wrapUpData.unknownCustomerName &&
      this.rootScope.activeCustTab?.wrapUpData.wrapupTopicList.length > 0 &&
      this.rootScope.activeCustTab?.wrapUpData.comments) {
      return true;

    }
    else return false;
  }



  /** 
* topicForm -- holding domain, topic & subTopic field value with validation .
* @author :Amarjeet Kumar
*/
  topicForm = new FormGroup({
    domain: new FormControl('', Validators.required),
    topic: new FormControl('', Validators.required),
    subTopic: new FormControl('', Validators.required),
  });


  /** 
 * checkData -- checking for cached data.
 * @author :Amarjeet Kumar
 */
  checkData() {
    if (this.rootScope.wrapupTopicDataMap[this.rootScope.activeCustTab.clientId])
      this.domainList = this.rootScope.wrapupTopicDataMap[this.rootScope.activeCustTab.clientId];
      this.domainList?.sort((a, b) => a?.topicName?.localeCompare(b?.topicName)); 

    if (this.rootScope.activeCustTab.wrapUpData?.wrapupTopicList?.length > 0) {
      this.rootScope.wrapupTopicList = this.rootScope.activeCustTab.wrapUpData.wrapupTopicList;
      if (!this.rootScope.activeCustTab?.wrapUpData?.primaryTopic)
        this.defaultPrimary();
    }
    else {
      this.rootScope.wrapupTopicList = [];
    }

    // CCR3-5305: Only inject default topic when simulation mode is active.
    if (this.rootScope?.simulationData?.isSimulationModeActive) {
      this.ensureDefaultSimulationTopic();
    }
    this.topicIndex = {
      id: null,
      name: null
    };
  }


  /** 
  * getTopicList -- creating topicList list After domain selection.
  * @author :Amarjeet Kumar
  */
  getTopicList(data: any, event: any) {
    if (event?.isUserInput) {
      this.topicList = data?.subTopicsist;
      this.topicList?.sort((a, b) => a?.topicName?.localeCompare(b?.topicName)); 
      this.topicForm.reset();
      this.subTopicList = [];
    }
  }


  /** 
  * getSubTopicList -- creating subTopicList list After topic selection.
  * @author :Amarjeet Kumar
  */
  getSubTopicList(data: any, event: any) {
    if (event?.isUserInput) {
      this.subTopicList = data?.subTopicsist;
      this.subTopicList?.sort((a, b) => a?.topicName?.localeCompare(b?.topicName)); 
      this.topicForm
        .get('subTopic')
        ?.setValue(null);
    }
  }


  /** 
   * addTopic -- adding topic list After clicking on add topic button.
   * @author :Amarjeet Kumar
   */
  addTopic() {
    this.duplicateTopic = this.tableData.find(x => x.domain == this.topicForm.get('domain')?.value && x.topic == this.topicForm.get('topic')?.value && x.subTopic == this.topicForm.get('subTopic')?.value)
    if (this.duplicateTopic == undefined) {
      this.tableData.push({
        domain: this.topicForm.get('domain')?.value,
        topic: this.topicForm.get('topic')?.value,
        subTopic: this.topicForm.get('subTopic')?.value,
      });
      this.dataSource = new MatTableDataSource<Element>(this.tableData);
      this.duplicateTopic = {};
      this.topicList = [];
      this.subTopicList = [];
      this.topicForm.reset();
    }
  }

  /** 
   * selectedRow --  After clicking on topic list highlighting selected row .
   * @author :Amarjeet Kumar
   */
  selectedRow(index) {
    this.index = index;
  }

  /** 
  * deleteTopic -- After topic selection on delete icon click action deleting the selected topic.
  * @author :Amarjeet Kumar
  */
  deleteTopic(index) {
    if (index != null) {
      this.dataSource.data.splice(index, 1);
      this.dataSource = new MatTableDataSource(this.tableData);
      this.index = null
    }
  }

  /** .
 * clearTopic -- clearing all dropdowns & topic list After clicking on Clear all button.
 * @author :Amarjeet Kumar
 */
  clearTopic() {
    this.topicForm.reset();
    this.dataSource = new MatTableDataSource();
    this.topicList = [];
    this.subTopicList = [];
    this.tableData = [];
    this.duplicateTopic = {};
  }

  /** 
 * submitTopic -- Submitting  topic list into wrapup form topic list After clicking on Submit button.
 * @author :Amarjeet Kumar
 */
  submitTopic() {
    this.showAddTopicModal = false;
    if (this.rootScope.wrapupTopicList.length > 0) {
      this.rootScope.wrapupTopicList = this.rootScope.wrapupTopicList.filter(x => {
        delete x.id;
        return true;
      });
    }

    this.rootScope.wrapupTopicList = [...this.rootScope.wrapupTopicList, ...this.tableData];
    let unique: any = Array.from(new Set(this.rootScope.wrapupTopicList.map(JSON.stringify)))
    this.rootScope.wrapupTopicList = unique.map(JSON.parse);
    if (this.rootScope.wrapupTopicList) {
      for (let i = 0; i < this.rootScope.wrapupTopicList.length; i++) {
        this.rootScope.wrapupTopicList[i].id = i;
      }
    }
    this.rootScope.activeCustTab.wrapUpData.wrapupTopicList = this.rootScope.wrapupTopicList;
    if (!this.rootScope.activeCustTab?.wrapUpData?.primaryTopic) {
      this.defaultPrimary();
    }
  }

  /** 
 * wrapupSelectedRow -- Highlighting row on topic selection.
 * @author :Amarjeet Kumar
 */
  topicIndex = {
    id: null,
    name: null
  };
  wrapupSelectedRow(row) {
    this.topicIndex = row;
  }

  /** 
 * makePrimary -- Making selected topic primary After clicking on "*" icon button.
 * @author :Amarjeet Kumar
 */
  makePrimary(topic) {
    if (topic.id != null) {
      this.rootScope.activeCustTab.wrapUpData.primaryTopic = topic?.domain + Constants.TOPIC_ARROW + topic.topic + Constants.TOPIC_ARROW +
        topic?.subTopic;
    }
  }


  /** 
 * deleteWrapupTopic -- Deleteting selected topic from Topic list After clicking on Delete icon.
 * @author :Amarjeet Kumar
 */
  deleteWrapupTopic(topic) {

    // Check if this is the default simulation topic
  if (this.isDefaultTopic(topic)) {
    return; // Cannot delete default simulation topic
  }

    if (topic.id != null) {
      this.rootScope.wrapupTopicList = this.rootScope.wrapupTopicList.filter(x => x.id != topic.id);
      this.topicIndex = {
        id: null,
        name: null
      };
      if (this.rootScope.activeCustTab.wrapUpData.primaryTopic == topic?.domain + Constants.TOPIC_ARROW + topic?.topic + Constants.TOPIC_ARROW + topic?.subTopic) {
        this.defaultPrimary();
        if (this.rootScope.wrapupTopicList.length == 0)
          this.rootScope.activeCustTab.wrapUpData.primaryTopic = null;
      }
      this.rootScope.activeCustTab.wrapUpData.wrapupTopicList = this.rootScope.wrapupTopicList;
    }
  }

  /**
   * Below method gets called when Close ACcount button is triggered.
   * It updates the IH model that is already created for current tab with 
   * detail /description and wrapUpdata  and triggres closing of the tab on 
   * click of this button. (for chat and call both) CCR1-3999.
   * Listener of variable "wrappedUpComplete" is in header.component.ts
   * @author :Pooja
   */

  closeAccountButtonClicked() {
    if (!this.rootScope.activeCustTab.wrappedupCroosIcon) {
      return;
    }
    this.rootScope.wrappedUpComplete.next(true);
  }

  /** 
 * defaultPrimary -- making first topic primary by default from Topic list.
 * @author :Amarjeet Kumar
 */
  defaultPrimary() {
    this.rootScope.activeCustTab.wrapUpData.primaryTopic = this.rootScope.wrapupTopicList[0]?.domain + Constants.TOPIC_ARROW + this.rootScope.wrapupTopicList[0]?.topic + Constants.TOPIC_ARROW +
      this.rootScope.wrapupTopicList[0]?.subTopic;
  }


  /* *Below method handle changne of unknown caller type drop-down value and
   * if the unknown caller type is selected Ghost Caller we are assigning some default values */
  onUnknownCallerTypeChange(event: any) {
    const previousType = this.rootScope.activeCustTab.wrapUpData.previousUknownCallerType;
    const currentType = event?.value;

    if (currentType === Constants.GHOST_CALLER) {
      this.rootScope.activeCustTab.wrapUpData.wrapupTopicList.length = 0;
      this.rootScope.activeCustTab.wrapUpData.unknownCustomerName = Constants.GHOST_CALLER;
      this.rootScope.activeCustTab.wrapUpData.wrapupTopicList.push(Constants.GHOST_CALLER_DEFAULT_TOPIC_LIST);

      // CCR3-5305 Re-add default simulation topic if in simulation mode
      if (this.rootScope?.simulationData?.isSimulationModeActive) {
        this.ensureDefaultSimulationTopic();
      }
      else {
        // CCR3-5305 Normal Ghost Caller mode (not simulation)
        this.rootScope.activeCustTab.wrapUpData.primaryTopic = Constants.GHOST_CALLER_DEFAULT_PRIMARY_TOPIC;
      }

      this.rootScope.activeCustTab.wrapUpData.comments = Constants.GHOST_CALLER_DEFAULT_COMMENT;
    }

    if (previousType === Constants.GHOST_CALLER) {
      this.rootScope.activeCustTab.wrapUpData.unknownCustomerName = '';
      this.rootScope.activeCustTab.wrapUpData.wrapupTopicList.length = 0;
      this.rootScope.activeCustTab.wrapUpData.primaryTopic = '';
      this.rootScope.activeCustTab.wrapUpData.comments = '';
      // CCR3-5305: Re-inject default simulation topic if simulation mode is active
      if (this.rootScope?.simulationData?.isSimulationModeActive) {
        this.ensureDefaultSimulationTopic();
      }
    }

    this.rootScope.wrapupTopicList = this.rootScope.activeCustTab.wrapUpData.wrapupTopicList;
    this.rootScope.activeCustTab.wrapUpData.previousUknownCallerType = currentType;
  }

  /**Below method hide unknown Caller Wrapup Page and display the duplicate Customer search page */
  hideUnknowncallerTab() {
    this.rootScope.activeCustTab.wrapUpData.unknownCallerWrapupPage = false;
    this.dataRetain.emit({});
  }

  

 /**Below method took the value of selected menu and selected sub-menu when user click
   *  on the any of the link of Unknown Caller Left Nav Bar and set it to the tab level 
   * variables which show the active link with blue color in the Left Nav Bar Link.*/
 activateLeftMenu(menu, subMenu) {
  this.rootScope.isErrorToHide = true;
  this.rootScope.isWarningToHide = true;
  this.rootScope.activeCustTab.unknownCallerLeftNav.selectedSubMenu = subMenu?.id;
  this.rootScope.activeCustTab.unknownCallerLeftNav.selectedMenu = menu?.id;
  let selectedLink = this.rootScope.activeCustTab.unknownCallerLeftNav?.unknownCallerNavBarData.find(xx => xx.id == menu?.id)?.subMenuList.find(x => x.id == subMenu?.id);
  if (selectedLink && selectedLink?.actionCode == "LINK_ACTION") {
    this.rootScope.selectedLeftNavBarLink(selectedLink, false);
  } else {
    this.rootScope.logEvent(Constants.ERROR, Constants.RSN_CODE_LINK_CONFIG_MISSING + ': Link Configuration is missing')
    this.rootScope.enableAlerts(Constants.ERROR, Constants.RSN_CODE_LINK_CONFIG_MISSING + ": " + Constants.AlertMsg.error500);

  }

}

/**
 * Below method  return the time of the live interaction.
 * @returns Total time of live Interaction(Call)
 */
  getTimerVal() {
    
    if (this.rootScope.activeCustTab.activeCall) {
      this.rootScope.activeCustTab.conversationConnectedTime = this.timerService.connectedTime;
      let currentTime = new Date().toISOString();
      return this.initHistService.getDuration(this.rootScope.activeCustTab.conversationConnectedTime, currentTime);
    } else {
      return this.initHistService.getDuration(this.rootScope.activeCustTab.conversationConnectedTime, this.rootScope.activeCustTab.conversationDisconnectedTime);
    }
  }

  /**
   * Below method return the start time of the call.
   * @returns Conversation Start Time
   */
  getStartTime() {
    let time = this.rootScope.activeCustTab.startTime;
    this.rootScope.activeCustTab.lastStartTime = this.initHistService.getTime(time);
    return this.rootScope.activeCustTab.lastStartTime;
  }


   /**Below method returns clientName .Used in left nav client Info
   * @author : Pooja Gupta
   */
   getClientName() {
    return this.customerService.getClientName(
      this.rootScope.activeCustTab ? this.rootScope.activeCustTab.clientId : '00095'
    );
  }

  /**
   * Below method check if the unknown caller nav bar data avialable in the Tab cache if there is no data avaiable
   * there would be a fresh API hit to backend for fetching the the left nav data.
  */
  getUnknownCallerLeftNavData() {
    const unknownCallerNavBarData = this.rootScope.activeCustTab?.unknownCallerLeftNav?.unknownCallerNavBarData;
    if (unknownCallerNavBarData === undefined || unknownCallerNavBarData.length === 0) {
      const payLoad = {
        value: this.rootScope.activeCustTab.clientId
      };
      this.rootScope.getUnknownCallerLeftNavData(payLoad);
    }
  }
  
   /** 
   * getDomainList -- calling API to get getDomainList.
     */
   getDomainList() {
    this.rootScope.domainListAPIFailure = false;
    this.apiService.getDomainList().subscribe({
      next: (data: any) => {
        this.rootScope.wrapupTopicDataMap[this.rootScope.activeCustTab.clientId] = data.data;
      },
      error: (error) => {
        this.rootScope.domainListAPIFailure = true;
        console.log(error);
      },
    })
  }
  /**
 * @author VamsiKrishna
 * @returns true/false
 * based on wrap up input fileds validation 
 * live call interaction status
 */
   enableSyncLink(){
    if(this.rootScope.activeCustTab.activeCall||this.rootScope.activeCustTab.activeChat){
      return this.wrapUpValidation();
    }
    else return false;
  }
  /**
  * @author VamsiKrishna
  * the livecall/chat status in active tab
  * 
  */
  /* istanbul ignore next */
  onClickLiveStatus() {
    this.rootScope.increAlisRefreshCounter('REFRESH_UNKNOWN_CALL_COUNT');// Called for increment refresh count on user refresh action-CCR3-6969
    this.rootScope.activeCustTab.wrapUpData.callStatus = "";
    this.genesysCloudService.syncLivestatus(this.rootScope.activeCustTab.channel);
  }

  onTextareaChanged(event: any) {
    if(event.detail?.value?.length) {  
      event.target.value = event?.detail?.value;
      this.rootScope.activeCustTab.wrapUpData.comments = event?.detail?.value;
    }
  }


  
  /**
   * Checks if there is an error message related to the call summary in the wrap-up data.
   *
   * Returns `true` if any of the following conditions are met:
   * - The call summary API is forbidden (`isCallSummaryApiForbidden`)
   * - The user does not have permission for the call summary API (`isCallSummaryApiNoPermission`)
   * - The call summary is too short (`isCallSummaryTooShort`)
   *
   * @returns {boolean} `true` if any call summary error condition exists, otherwise `false`.
   */
  checkSummaryErrorMessage() {
    const aiSummaryStatus = this.rootScope.activeCustTab?.aiSummaryStatus || {};
    return !!(
      aiSummaryStatus?.isCallSummaryApiForbidden ||
      aiSummaryStatus?.isCallSummaryApiNoPermission ||
      aiSummaryStatus?.isCallSummaryTooShort
    );
  }

  
  /**
   * Determines whether the "Get Summary" button should be enabled or disabled.
   *
   * The button is enabled if there is an active call, an active chat, or if the call summary is currently being fetched.
   * Returns `true` if any of these conditions are met, otherwise returns `false`.
   *
   * @returns {boolean} `true` if the button should be enabled; `false` otherwise.
   */
  checkGetSummaryButtonEnabledOrDisabled(): boolean {

    // CCR3-5305 Disable the button if simulation mode is active.
    if (this.rootScope?.simulationData?.isSimulationModeActive) {
    return true; 
    }
    const aiSummaryStatus = this.rootScope.activeCustTab?.aiSummaryStatus || {};
    return !!(
      this.rootScope.activeCustTab?.activeCall ||
      this.rootScope.activeCustTab?.activeChat ||
      this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryAvailable ||
      aiSummaryStatus?.isCallSummaryFetching
    );
  }

   /**
   * Resets all call summary error flags in the wrap-up data.
   * Clears permission, length, forbidden, and generic error states.
   */
  closeAlertMessage(){
    this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryApiNoPermission = false;
    this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryTooShort = false;
    this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryApiForbidden = false;
    this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryApiError = false;
  }


  /**
   * Handles the click event for fetching conversation summaries.
   * Closes any active alert messages and requests summaries from Genesys Cloud
   * using the current active customer's conversation ID.
   */
  onClickSummaries(){
    this.closeAlertMessage();
    this.rootScope.activeCustTab.aiSummaryStatus.isCallSummaryFetching = true;
    this.genesysCloudService.getSummaries(this.rootScope.activeCustTab?.conversationId);
  }
 

/**
 * CCR3-5305 Checks if a topic is the default simulation topic and should not be deletable
 * @param topic - The topic to check
 * @returns boolean - true if topic is default and cannot be deleted
 */
isDefaultTopic(topic: any): boolean {
  return !!(topic?.isDefault);
}


/**
 * CCR3-5305 Ensures that the default simulation topic is present in the wrap-up topic list
 * Only called when simulation mode is active
 */
ensureDefaultSimulationTopic(): void {
  // Step 1: Make sure wrapupTopicList is an array
  if (!Array.isArray(this.rootScope.wrapupTopicList)) {
    this.rootScope.wrapupTopicList = [];
  }

  // Step 2: Check if default topic already exists
  const exists = this.rootScope.wrapupTopicList.some((t: any) =>
    t?.isDefault || // Look for topic marked as default
    (t?.domain === this.DEFAULT_SIM_TOPIC.domain &&
      t?.topic === this.DEFAULT_SIM_TOPIC.topic &&
      t?.subTopic === this.DEFAULT_SIM_TOPIC.subTopic)
  );

  // Step 3: If it doesn't exist, add it
  if (!exists) {
    // Put default first so it is visible and preserved
    this.rootScope.wrapupTopicList = [{ ...this.DEFAULT_SIM_TOPIC }, ...this.rootScope.wrapupTopicList];

    // Assign ids (keep default id stable)
    for (let i = 0; i < this.rootScope.wrapupTopicList.length; i++) {
      if (!this.rootScope.wrapupTopicList[i].isDefault) {
        this.rootScope.wrapupTopicList[i].id = i;
      }
    }

    // Persist back to active tab
    this.rootScope.activeCustTab.wrapUpData = this.rootScope.activeCustTab.wrapUpData || {};
    this.rootScope.activeCustTab.wrapUpData.wrapupTopicList = this.rootScope.wrapupTopicList;

    // Ensure primary exists
    if (!this.rootScope.activeCustTab?.wrapUpData?.primaryTopic) {
      this.defaultPrimary();
    }
  }
}


}
